import React, { ReactNode } from 'react';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { Stack, Typography, Alert } from '@mui/material';

interface Props {
  form: ReactNode;
  rules: ReactNode;
  workflow: ReactNode;
}

export const SalesCenterLayout = ({ workflow, rules, form }: Props) => {
  const classes = useStyles();

  return (
    <Stack className={classes.root}>
      <Alert severity="info">
        <Typography>
          Configure default workflow rules for deal sheets based on customer type, location, equipment type, sales type,
          and service type. Set up the fees and taxes that should be automatically applied for each scenario. Taxes can
          be configured at federal, state, county, and city levels with ZIP code lookup support. Use bulk import/export
          for managing multiple rules.
        </Typography>
      </Alert>

      {form}

      {workflow}

      {rules}
    </Stack>
  );
};

const useStyles = makeStyles(({ shadows }) => ({
  root: {
    gap: '1rem',
    padding: '1rem',
    backgroundColor: 'white',

    '& .salesCenterCard': {
      padding: '1rem',
      boxShadow: shadows[1],
      borderRadius: '0.5rem',
      backgroundColor: 'white',
      border: `1px solid ${grey[300]}`,
    },
  },
}));
